import { useMutation } from '@tanstack/react-query';
import { conversationsApi } from '@/entities/conversation';

/**
 * "Перейти в чат" from an order row (cpanel `navigateChat` → `useChatList` /
 * `useCreateChat`): reuse the order's active courier chat when one exists,
 * otherwise open a new one, then hand the chat id to `onOpen` (the route
 * navigates to the inbox). A failed create stays silent, as in cpanel.
 */
export function useOpenOrderChat(onOpen: (chatId: string) => void) {
  return useMutation({
    meta: { suppressErrorToast: true },
    mutationFn: async (orderId: string | number) =>
      (await conversationsApi.findOrderCourierChat(orderId)) ??
      (await conversationsApi.createOrderCourierChat(orderId)),
    onSuccess: (chatId) => {
      if (chatId) onOpen(chatId);
    },
  });
}
